import Core         from '@/core/Core';
import BaseService  from '@/core/services/BaseService';
import BookmarksDAO from "@/domains/Bookmark/BookmarksDAO";

class BookmarksService extends BaseService {

    static get dao() {
        return BookmarksDAO;
    }

    static async add(productCategoryId: number): Promise<boolean> {
        const response = await this.dao.add(productCategoryId);

        if (response.ok) {
            Core.showNotification.success('Добавлено в избранное');
        }

        return response.ok;
    }

    static async delete(productCategoryId: number): Promise<boolean> {
        const response = await this.dao.delete(productCategoryId);

        if (response.ok) {
            Core.showNotification.success('Удалено из избранного');
        }

        return response.ok;
    }
}

export default BookmarksService;
